import Order from '../entity/order';
import ProductCategory from '../entity/productCategory';
import Product from '../entity/product';
import PageInfo from '../entity/pageInfo';
import { OrderType } from '../service/productRepository'
import OrderProduct from "../entity/orderProduct";

const START_FETCH = 'contentSelect#startFetch';
const FINISH_FETCH = 'contentSelect#finishFetch';
const SET_ORDER = 'contentSelect#setOrder';
const SET_ORDER_PRODUCTS = 'contentSelect#setOrderProducts';
const SET_PRODUCT_CATEGORIES = 'contentSelect#setProductCategories';
const SET_PRODUCTS = 'contentSelect#setProducts';
const NEXT_PRODUCT_PAGE = 'contentSelect#nextProductPage';
const DISPOSE = 'contentSelect#dispose';

export type OrderProductType = Map<string, OrderProduct>;
export type FinishType = {
  order: Order;
  orderProducts: OrderProductType;
  productCategories: ProductCategory[];
  products: Product[];
  productPageInfo: PageInfo;
};

export type SearchProductInputType = {
  display?: boolean;
  categoryId?: string;
}

export type SearchProductType = {
  order?: OrderType;
  name?: string;
  searchInput?: SearchProductInputType;
};

export type NextProductPageType = {
  orderProducts: OrderProductType;
  products: Product[];
  pageInfo?: PageInfo;
  searchParam?: SearchProductType;
};

export type State = {
  order: Order;
  orderProducts: OrderProductType;
  products: Product[];
  productPageInfo: PageInfo;
  productSearchParams: SearchProductType;
  productCategories: ProductCategory[];
  fetches: number;
};

type Action = {
  type: typeof START_FETCH
    | typeof FINISH_FETCH
    | typeof SET_ORDER
    | typeof SET_ORDER_PRODUCTS
    | typeof SET_PRODUCT_CATEGORIES
    | typeof SET_PRODUCTS
    | typeof NEXT_PRODUCT_PAGE
    | typeof DISPOSE;
  payload?: Order
    | OrderProductType
    | ProductCategory[]
    | Product
    | Product[]
    | NextProductPageType
    | FinishType
    | null;
};

export const initialState = {
  order: new Order({}),
  orderProducts: new Map(),
  products: [],
  productCategories: [],
  productPageInfo: new PageInfo({}),
  productSearchParams: {
    searchInput: {},
    order: {
      target: 'sort',
      direction: 'asc',
    } as OrderType,
  },
  fetches: 0,
};

const contentSelect = (previousState: State = initialState, { type, payload }: Action): State => {
  if (type === START_FETCH) {
    return {
      ...previousState,
      order: previousState.order,
      fetches: previousState.fetches + 1,
    };
  }

  if (type === FINISH_FETCH) {
    const __payload = payload as FinishType || null;

    if (!__payload) {
      return {
        ...previousState,
        fetches: 0,
      };
    }

    return {
      ...previousState,
      order: __payload.order,
      orderProducts: __payload.orderProducts,
      productCategories: __payload.productCategories,
      products: __payload.products,
      productPageInfo: __payload.productPageInfo,
      fetches: 0,
    };
  }

  if (type === SET_ORDER) {
    return {
      ...previousState,
      order: payload as Order,
    };
  }

  if (type === SET_ORDER_PRODUCTS) {
    return {
      ...previousState,
      orderProducts: payload as OrderProductType,
    };
  }

  if (type === SET_PRODUCT_CATEGORIES) {
    return {
      ...previousState,
      productCategories: payload as ProductCategory[],
    };
  }

  if (type === NEXT_PRODUCT_PAGE) {
    const __payload = payload as NextProductPageType;

    return {
      ...previousState,
      orderProducts: __payload.orderProducts,
      products: __payload.products,
      productPageInfo: __payload.pageInfo as PageInfo,
      productSearchParams: __payload.searchParam as SearchProductType,
    };
  }

  if (type === DISPOSE) {
    return {
      ...initialState,
      orderProducts: new Map(),
    };
  }

  return previousState;
};

export const startFetch = (): Action => ({ type: START_FETCH });

export const finishFetch = (payload: FinishType | null): Action => ({
  type: FINISH_FETCH,
  payload,
});

export const setOrder = (order: Order | null): Action => ({
  type: SET_ORDER,
  payload: order,
});

export const setOrderProducts = (orderProducts: OrderProductType): Action => ({
  type: SET_ORDER_PRODUCTS,
  payload: orderProducts,
});


export const setProductCategories = (productCategories: ProductCategory[]): Action => ({
  type: SET_PRODUCT_CATEGORIES,
  payload: productCategories,
});

export const nextProductPage = (payload: NextProductPageType): Action => ({
  type: NEXT_PRODUCT_PAGE,
  payload,
});

export const dispose = (): Action => ({ type: DISPOSE });

export default contentSelect;
